import { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import useCreateCoreProductCategory from "../../services/useCreateCoreProductCategory";

interface CategoryFormProps {
  onSuccess?: () => void;
  onError?: (message: string) => void;
}

/**
 * Formulário para criação de nova categoria de produto
 */
const CategoryForm = ({ onSuccess, onError }: CategoryFormProps) => {
  const [name, setName] = useState("");
  const [order, setOrder] = useState<string>("");

  const createCategoryMutation = useCreateCoreProductCategory();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!name.trim()) {
      onError?.("O nome da categoria é obrigatório");
      return;
    }

    const payload: { name: string; order?: number } = {
      name: name.trim(),
    };

    if (order !== "") {
      payload.order = parseInt(order, 10);
    }

    createCategoryMutation.mutate(payload, {
      onSuccess: () => {
        setName("");
        setOrder("");
        onSuccess?.();
      },
      onError: (err: any) => {
        console.error("Erro ao criar categoria", err);
        const data = err?.response?.data ?? err;
        if (data && typeof data === "object") {
          const errorMessages = Object.keys(data).map((key) => {
            const value = (data as any)[key];
            const messages = Array.isArray(value) ? value : [value];
            return `${key}: ${messages.join(", ")}`;
          });
          onError?.(errorMessages.join("\n"));
        } else {
          onError?.("Erro ao criar categoria. Tente novamente.");
        }
      },
    });
  };

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Nova Categoria
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}
        >
          <TextField
            label="Nome"
            value={name}
            onChange={(e) => setName(e.target.value)}
            size="small"
            required
            sx={{ flexGrow: 1 }}
          />
          <TextField
            label="Ordem"
            type="number"
            value={order}
            onChange={(e) => setOrder(e.target.value)}
            size="small"
            sx={{ width: 100 }}
            helperText="Opcional"
          />
          <Button
            type="submit"
            variant="contained"
            startIcon={<AddIcon />}
            disabled={createCategoryMutation.isLoading}
            sx={{ height: 40 }}
          >
            {createCategoryMutation.isLoading ? "Criando..." : "Criar"}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CategoryForm;
